import { ColumnDef } from "@tanstack/react-table";
import { TransactionStatus } from "@/core/components/transaction-status";
import {
  INTERNAL_TRANSACTION_STATUS,
  INTERNAL_TRANSACTION_STATUS_TO_LABEL,
  INTERNAL_TRANSACTION_STATUS_TO_PROGRESS,
} from "@/internal-transactions/constants";
import {
  IInternalTransaction,
  InternalTransactionStatus,
} from "@/internal-transactions/InternalTransactions";

const Content = ({ status }: { status: InternalTransactionStatus }) => {
  const label = INTERNAL_TRANSACTION_STATUS_TO_LABEL[status];
  const progress = INTERNAL_TRANSACTION_STATUS_TO_PROGRESS[status];
  const isError = status === INTERNAL_TRANSACTION_STATUS.failed;

  return (
    <TransactionStatus label={label} progress={progress} isError={isError} />
  );
};

export const StatusCol = (): ColumnDef<IInternalTransaction> => ({
  header: "Status",
  accessorKey: "status",
  cell: ({ row }) => <Content status={row.original.status} />,
});
